import { useEffect, useState } from 'react';

import { useBookingModals } from '../store/bookingModals';

interface OTPModalHook {
  openOTPModal: boolean;
  timerHideModalsHandler: () => void;
  hideOTPModal: () => void;
  showOTPModal: () => void;
}

export const useOTPModal = (): OTPModalHook => {
  const { setVisibleBookingModal } = useBookingModals();

  const [openOTPModal, setOpenOTPModal] = useState<boolean>(false);

  const [timerHideOTPModal, setTimerHideOTPModal] = useState<NodeJS.Timeout | number | null>(null);
  const [timerHideModal, setTimerHideModal] = useState<NodeJS.Timeout | number | null>(null);

  const hideOTPModal = () => setOpenOTPModal(false);
  const showOTPModal = () => setOpenOTPModal(true);

  const timerHideModalsHandler = () => {
    if (timerHideModal) {
      clearTimeout(timerHideModal);
      setTimerHideModal(null);
    }

    if (timerHideOTPModal) {
      clearTimeout(timerHideOTPModal);
      setTimerHideOTPModal(null);
    }

    const timerMain = setTimeout(() => {
      setVisibleBookingModal(false);

      const timerOTPModal = setTimeout(hideOTPModal, 1500);

      setTimerHideOTPModal(timerOTPModal);
    }, 1000);

    setTimerHideModal(timerMain);
  };

  useEffect(() => {
    return () => {
      if (timerHideModal) {
        clearTimeout(timerHideModal);
      }

      if (timerHideOTPModal) {
        clearTimeout(timerHideOTPModal);
      }
    };
  }, [timerHideModal, timerHideOTPModal]);

  return {
    openOTPModal,

    timerHideModalsHandler,
    hideOTPModal,
    showOTPModal,
  };
};
